// extracted by mini-css-extract-plugin
export var Layout_Header = "styles-module--Layout_Header--lb0wT";